import { render } from "./AppsDetails.vue?vue&type=template&id=4b848654"
import script from "./AppsDetails.vue?vue&type=script&lang=js"
export * from "./AppsDetails.vue?vue&type=script&lang=js"

import "./AppsDetails.vue?vue&type=style&index=0&id=4b848654&lang=css"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__